<!-- MOLECULE: PatientRecordActions.vue -->

<script setup lang="ts">
//
// Imports
//

import AppBarActionButton from "./AppBarActionButton.vue";

//
// Composables
//

const { t } = useI18n();

/**
 * Loading state for the currently active tab.
 * Reads the same useState keys that usePatientRecordPage writes to,
 * so the refresh button reflects the real loading state without
 * instantiating the page composable (which would create duplicate watchers).
 */
const visitsLoading = useState<boolean>("patient-record.visitsLoading", () => false);
const testsLoading = useState<boolean>("patient-record.testsLoading", () => false);
const activeTab = useCookie<"visits" | "tests">("patientRecord.activeTab", {
  default: () => "visits",
});

//
// Computed
//

/** Show loading spinner for whichever tab is currently active */
const loading = computed(() =>
  activeTab.value === "visits" ? visitsLoading.value : testsLoading.value,
);

//
// State
//

/**
 * Shared refresh trigger — usePatientRecordPage watches this useState counter.
 * Incrementing it here triggers a reload without instantiating the full
 * page composable (which would register duplicate watchers + onMounted).
 */
const refreshTrigger = useState<number>("patient-record.refreshTrigger", () => 0);

//
// Methods
//

function triggerRefresh(): void {
  refreshTrigger.value++;
}
</script>

<template>
  <app-bar-action-button
    icon="mdi-refresh"
    :tooltip-text="t('pages.patient-record.actions.refresh')"
    :loading="loading"
    :disabled="loading"
    @click="triggerRefresh"
  />
</template>
